import { PopinProps } from '../../components/Popin'
import ActionButton, { ActionButtonProps } from '../../components/ActionButton'

export const planningWelcomeBackModalTransformer = (
  t?: any,
  isOpen?: boolean,
  handleClose?: () => void,
  buttons?: ActionButtonProps[]
): PopinProps => ({
  title: t('planning_welcomeback_modal_title'),
  textsContent: (
    <p
      dangerouslySetInnerHTML={{
        __html: t('planning_welcomeback_modal_description'),
      }}
    />
  ),
  buttonsContent: (
    <div className="mobile-reverse">
      {buttons &&
        buttons.map((button) => <ActionButton key={button.text} {...button} />)}
    </div>
  ),
  isOpen,
  handleClose,
  imageProps: {
    src: '/images/onboarding/target.png',
    alt: '',
    height: 342,
    width: 480,
  },
  buttonsContentInRow: true,
})
